import {Component} from 'react'
import PropTypes from 'prop-types'

import AsyncTypeahead from './AsyncTypeahead.jsx'

import api from '../../../../api.js'

export default class CityTypeahead extends Component {
  static propTypes = {
    promptText: PropTypes.string,
    hasCountriesRestriction: PropTypes.bool
  }

  static defaultProps = {
    promptText: 'Entrez le nom de la ville',
    hasCountriesRestriction: true,
  }

  search = async (query) => {
    return (await api.cities.getAll(
      {keyword: query, hasCountriesRestriction: this.props.hasCountriesRestriction}
    )).data
  }

  valueFieldFromFormat = (val) => {
    return val.length === 0 ? [{label: ''}] : val
  }

  render() {
    const {valueField, type, ...rest} = this.props
    let value = this.props.input.value

    if (value && Array.isArray(this.props.input.value)) {
      value = this.props.input.value[0]
    }

    return <AsyncTypeahead
      defaultSelected={(value ? [value] : [])}
      onSearch={this.search}
      valueField={this.valueFieldFromFormat}
      {...rest}
    />
  }
}
